// generated from 4_437_289 samples

import { z } from "zod";
import { common } from "../common";
import { appliedTemplateSchema } from "./appliedTemplateSchema";
import { linkConfigSetSchema } from "../shared/linkConfigSetSchema";
import { multiLanguageCompositionSetupSchema } from "../shared/multiLanguageCompositionSetupSchema";

export const messageGetBaseSchema = z.object({
  // null: 2_953 (0.07%)
  // format uuid: 4_429_447 (99.89%)
  api_message_id: z.string().nullable(),
  campaign_base_id: common.objectId,
  // true 4_355_900 (98.17%), false 81_389 (1.83%)
  is_active: z.boolean(),
  // true 525_152 (11.83%), false 3_912_137 (88.17%)
  is_control: z.boolean(),
  // null: 237_884 (5.36%)
  link_config_set: linkConfigSetSchema.nullable(),
  // null: 268 (0.01%)
  link_template_ids: z.array(common.objectId).nullable(),
  message_type: z.string(),
  // null: 2_714_953 (61.18%)
  name: z.string().nullable().optional(),
  // null: 4_436_323 (99.98%)
  // avg: 26.68, min: 0, max: 100
  optimal_send_percentage: z.int().min(0).max(100).nullable().optional(),
  // null: 128_627 (2.90%)
  // avg: 16.70, min: 0, max: 10220122
  send_percentage: z.int().min(0).nullable(),
  // null: 9 (0.00%)
  variation_id: common.objectId,
  variant_group_id: z.string().nullable().optional(),
  // Multi-language composition setup for translations
  multi_language_composition_setup: multiLanguageCompositionSetupSchema.nullable().optional(),
  draft_link_management_data: z.string().optional(),
  draft_link_alias_includer_state: z.string().optional(),
  // Present only when the variation was created from a template; null once a post-to-get conversion clears it
  applied_template: appliedTemplateSchema.nullable().optional(),
  // this can be either { image_url: string } or { html: true } or { template_name: string } or string or null
  preview_snippet: z
    .union([
      z.object({ image_url: z.string() }),
      z.object({ html: z.literal(true) }),
      z.object({ template_name: z.string() }),
      z.string(),
    ])
    .nullable()
    .optional(),
});
